import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { shortUuid } from "@egalregal/shared";
import { useT } from "../../shared/i18n";

/**
 * The `offline-uncached` preview body: the label may be perfectly valid, but
 * neither the read cache nor the network can answer, so the scanner says
 * exactly that instead of reporting an unknown code (scan-resolution 02). The
 * retry re-runs the same resolution without recording a second scan.
 */
export function OfflineUncachedMessage({
  code,
  onRetry,
}: {
  code: string;
  onRetry: () => void;
}) {
  const t = useT();
  return (
    <Box data-testid="scan-offline-uncached">
      <Typography variant="body2" color="text.secondary">
        {t("scanOfflineUncached")}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mt: 0.5 }}
      >
        {shortUuid(code)}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        data-testid="scan-offline-retry"
        onClick={onRetry}
        sx={{ mt: 1 }}
      >
        {t("scanRetry")}
      </Button>
    </Box>
  );
}
